export default {
  state: {
    preloaderStatus: false,
  },
  mutations: {
    TOGGLE_PRELOADER: (state, payload) => {
      state.preloaderStatus = (payload ? payload : !state.preloaderStatus);
    },
  },
  actions: {
    togglePreloader: ({ commit }, payload) => {
      commit('TOGGLE_PRELOADER', payload);
    },
  }
};
